import React from 'react';
import VideoTableList from '@opm/pages/Videos/VideoTable';
import { useScrollBottomRegister } from '@opm/components/ScrollBottomList';
import { gotoDownload } from '@opm/pages/Download';
import { DBO_TM } from '@op/utils/format';
import { useUgcRelatedVideos } from '../../../hooks';
import { toBackendSortItem } from '../../../hooks/useUgcRelatedVideos';

interface IRelatedVideosSectionProps {
  filter: any;
}

/**
 * UGC Details · Related Videos
 *
 * 直接复用 `@opm/pages/Videos/VideoTable`（VideoTableList）—— 组件零改动：
 *  - `useUgcRelatedVideos` 通过 `toVideoCardItem` 把后端字段映射成 VideoTableList 期望的形状
 *    （views/likes/cover/url/duration/channel/username/video_title*）
 *  - 唯一业务差异是 Date 排序 key（前端 `video_release_time` ↔ 后端 `comment_time`），
 *    由 hook 在拼装请求参数时单向翻译，组件层无感知
 */
export default function RelatedVideosSection({
  filter,
}: IRelatedVideosSectionProps) {
  const {
    cardRecords,
    tableRecords,
    total,
    pageInfo,
    changeTablePageInfo,
    loadNextPage,
    loading,
    sortBy,
    setSortBy,
    keyword,
    setKeyword,
    viewMode,
    setViewMode,
  } = useUgcRelatedVideos({ filter });

  // 卡片视图 infinite scroll —— VideoTableList 不自带，由消费方注册
  useScrollBottomRegister(loadNextPage);

  function handleDownload() {
    gotoDownload({
      key: 'MarketingUgcRelatedVideosDownload',
      fileName: `UGC_Related_Videos_${filter?.topic || ''}_${DBO_TM.timeTitle(
        filter,
      )}`,
      filter: {
        ...filter,
        // 下载接口和 list 接口共用 sort_item 约定，同样把 Date 列翻译到后端 `comment_time`
        sort_item: toBackendSortItem(sortBy?.by),
        sort_model: sortBy?.order,
      },
    });
  }

  return (
    <VideoTableList
      cardRecords={cardRecords}
      tableRecords={tableRecords}
      total={total}
      pageInfo={pageInfo}
      changePageInfo={changeTablePageInfo}
      loading={loading}
      sortBy={sortBy}
      setSortBy={setSortBy}
      keyword={keyword}
      setKeyword={setKeyword}
      operation={viewMode}
      setOperation={setViewMode}
      download={handleDownload}
    />
  );
}
